import React from 'react';

const createSyntheticEvent = <T extends Element, E extends Event>(event: E): React.SyntheticEvent<T, E> => {
  let isDefaultPrevented = false;
  let isPropagationStopped = false;
  const preventDefault = () => {
    isDefaultPrevented = true;
    event.preventDefault();
  };
  const stopPropagation = () => {
    isPropagationStopped = true;
    event.stopPropagation();
  };
  return {
    nativeEvent: event,
    currentTarget: event.currentTarget as EventTarget & T,
    target: event.target as EventTarget & T,
    bubbles: event.bubbles,
    cancelable: event.cancelable,
    defaultPrevented: event.defaultPrevented,
    eventPhase: event.eventPhase,
    isTrusted: event.isTrusted,
    preventDefault,
    isDefaultPrevented: () => isDefaultPrevented,
    stopPropagation,
    isPropagationStopped: () => isPropagationStopped,
    persist: () => {},
    timeStamp: event.timeStamp,
    type: event.type,
  };
};

/**
 * Для всплытия эвентов в реакте тогда, когда внешняя библиотера не дает
 * стандартные эвенты к примеру Change
 * @link https://stackoverflow.com/questions/27062455/reactjs-can-i-create-my-own-syntheticevent
 */
export const buildChangeEvent = (value: string): React.ChangeEvent<HTMLInputElement> => {
  const target = document.createElement('input');
  target.value = value;
  const ev = new Event('change', { bubbles: true });
  Object.defineProperty(ev, 'target', { writable: false, value: target });
  return createSyntheticEvent(ev) as React.ChangeEvent<typeof target>;
};

/**
 * @TODO: Соединить с buildChangeEvent, который умеет только string тип
 * Для всплытия эвентов в реакте тогда, когда внешняя библиотера не дает
 * стандартные эвенты к примеру Change
 * @link https://stackoverflow.com/questions/27062455/reactjs-can-i-create-my-own-syntheticevent
 */
export const buildChangeEventObject = (value: string): React.ChangeEvent<HTMLFormElement> => {
  const target = document.createElement('form');
  target.value = value;
  const ev = new Event('change', { bubbles: true });
  Object.defineProperty(ev, 'target', { writable: false, value: target });
  return createSyntheticEvent(ev) as React.ChangeEvent<typeof target>;
};
